import React, { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";
import { faqs } from "../mock";

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="py-20 lg:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs uppercase tracking-widest text-cyan-700 font-bold">FAQ</div>
          <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-slate-900 leading-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-slate-600">
            Quick answers to common questions about 411TechSavvy services. Don&rsquo;t see your question? Use
            the chat or contact form below.
          </p>
        </div>

        <div className="mt-12 space-y-3">
          {faqs.map((item, idx) => {
            const open = idx === openIdx;
            return (
              <div
                key={idx}
                className={`rounded-xl border bg-white transition-all ${
                  open ? "border-cyan-500 shadow-md" : "border-slate-200"
                }`}
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  className="w-full flex items-center gap-4 p-5 text-left"
                >
                  <div
                    className={`h-9 w-9 rounded-lg grid place-items-center flex-shrink-0 ${
                      open ? "bg-cyan-600 text-white" : "bg-slate-100 text-slate-600"
                    }`}
                  >
                    <HelpCircle className="h-5 w-5" />
                  </div>
                  <span className="flex-1 font-semibold text-slate-900">{item.q}</span>
                  <ChevronDown
                    className={`h-5 w-5 text-slate-500 transition-transform ${open ? "rotate-180" : ""}`}
                  />
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-[68px] text-slate-600 leading-relaxed">{item.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
